// extracted by mini-css-extract-plugin
module.exports = {"view":"_11g1qrR7-ZHG1TWp0VkOO3","categoryImg":"_q3dDtS7AZ_o5BqK1KROI"};